//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { HandsfreeShoppingLargeSVG } from './svg'

interface HandsfreeShoppingLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const HandsfreeShoppingLargeIcon: React.FC<HandsfreeShoppingLargeIconProps> = forwardRef<
  HandsfreeShoppingLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={HandsfreeShoppingLargeSVG}
    sx={sx}
  />
))
